'use es6';

import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { Component } from 'react';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import spinner from 'bender-url!../../img/spinner.png';

var PreviewScreenshot = /*#__PURE__*/function (_Component) {
  _inherits(PreviewScreenshot, _Component);

  function PreviewScreenshot() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, PreviewScreenshot);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(PreviewScreenshot)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.renderImage = function () {
      var _this$props = _this.props,
          previewUrl = _this$props.previewUrl,
          error = _this$props.error;

      if (previewUrl) {
        return /*#__PURE__*/_jsx("img", {
          src: previewUrl,
          className: "screenshot"
        });
      } else if (error) {
        return /*#__PURE__*/_jsxs("div", {
          className: "error",
          children: [/*#__PURE__*/_jsx("div", {
            className: "icon icon-profile-spy"
          }), /*#__PURE__*/_jsx("div", {
            className: "error-text",
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "results.preview.error"
            })
          })]
        });
      } else {
        return /*#__PURE__*/_jsx("div", {
          className: "loader",
          children: /*#__PURE__*/_jsx("img", {
            src: spinner
          })
        });
      }
    };

    return _this;
  }

  _createClass(PreviewScreenshot, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          backgroundUrl = _this$props2.backgroundUrl,
          isMobile = _this$props2.isMobile;
      var rootClasses = "preview" + (isMobile ? " mobile" : "");

      if (isMobile) {
        return /*#__PURE__*/_jsxs("div", {
          "data-vr-ignore": true,
          className: rootClasses,
          children: [this.renderImage(), /*#__PURE__*/_jsx("img", {
            className: "frame",
            src: backgroundUrl
          })]
        });
      }

      return /*#__PURE__*/_jsxs("div", {
        "data-vr-ignore": true,
        className: rootClasses,
        children: [/*#__PURE__*/_jsxs("div", {
          className: "bar",
          children: [/*#__PURE__*/_jsx("div", {
            className: "bar-button"
          }), /*#__PURE__*/_jsx("div", {
            className: "bar-button"
          }), /*#__PURE__*/_jsx("div", {
            className: "bar-button"
          })]
        }), this.renderImage()]
      });
    }
  }]);

  return PreviewScreenshot;
}(Component);

PreviewScreenshot.propTypes = {
  backgroundUrl: PropTypes.string,
  previewUrl: PropTypes.string,
  isMobile: PropTypes.bool,
  error: PropTypes.bool
};
export { PreviewScreenshot as default };